const AirtableSyncIcon = ({ className, title }) => (
  <svg
    aria-hidden={title ? undefined : 'true'}
    className={className}
    fill='none'
    height='17'
    role={title ? 'img' : undefined}
    viewBox='0 0 15 17'
    width='15'
    xmlns='http://www.w3.org/2000/svg'
  >
    {title && <title>{title}</title>}
    <path
      d='M9.15 0.6L15 5.5L9.15 10.4V7.35H0V3.65H9.15V0.6Z'
      fill='currentColor'
    />
    <path
      d='M5.85 16.4L0 11.5L5.85 6.6V9.65H15V13.35H5.85V16.4Z'
      fill='currentColor'
    />
  </svg>
)

export default AirtableSyncIcon
